import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import classNames from 'classnames';
import Modal from 'react-responsive-modal';
import SelectComponent from '../components/ui/SelectComponent'
import categoryOptions from '../data/category';
import Footer from '../components/company/footer';
import ProjectDetails from '../components/ProjectDetails'

import closeLight from '../assets/images/close-light.png'
import closeDark from '../assets/images/close-dark.png'
import amlogo from '../assets/images/company-client-landing-page-auditionmagiciconplain@2x.png'
import QRCode from 'qrcode-react';
import project_details_logo1 from '../assets/images/expanded-project-shape-4@2x.png'
import project_details_logo1_dark from '../assets/images/expanded-project-responsive-shape-4@2x.png'
import project_details_logo2 from '../assets/images/check-in-expanded-01-copy-10-shape-5@2x.png'
import project_details_logo2_dark from '../assets/images/expanded-project-responsive-shape-5@2x.png'
import project_details_logo3 from '../assets/images/expanded-project-shape-6@2x.png'
import project_details_logo3_dark from '../assets/images/expanded-project-responsive-shape-6@2x.png'
import project_details_logo4 from '../assets/images/check-in-expanded-01-copy-10-shape-7@2x.png'
import project_details_logo4_dark from '../assets/images/expanded-project-responsive-shape-7@2x.png'
import project_details_logo5 from '../assets/images/expanded-project-shape-8@2x.png'
import project_details_logo5_dark from '../assets/images/expanded-project-responsive-shape-8@2x.png'
import project_details_logo6 from '../assets/images/check-in-expanded-01-copy-10-path-6@2x.png'
import project_details_logo7 from '../assets/images/check-in-expanded-01-copy-10-shape-9@2x.png'
import project_details_logo8 from '../assets/images/check-in-expanded-01-copy-10-shape-10@2x.png'
import project_details_logo6_dark from '../assets/images/expanded-project-responsive-path-1@2x.png'
import project_details_logo7_dark from '../assets/images/company-landing-page--register-col-path@2x.png'

import agent from '../agent'

const renderField = ({ input, className, label, type, question, meta: { asyncValidating, touched, error, warning } }) => {
  if (touched && error) {
    if (type === 'text')
      return (
        <div className={className}>
        <div className="input-field">
          <label className="is-invalid-label">{question.question}
            <input 
              {...input} 
              type={type}
              className="is-invalid-input" 
              placeholder={label} />
            <span className="form-error is-visible" id="uuid">{error}</span>
            { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
          </label>
        </div>
        </div>
      )
  }
  if (type === 'text') {
    return (
      <div className={className}>
      <div className="input-field">
        <label>{question.question}
          <input {...input} placeholder={label} type={type} />
          { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
        </label>
      </div>
      </div>
    )
  }
}

const renderError = ({ meta: { touched, error } }) => 
  touched && error ? <p className="form-error is-visible" id="uuid">{error}</p> : false 

class ProjectList extends Component {  
  state = {
    register: 'button header-button-selected',
    checkin: 'button header-button-unselected',
    pagestate: 'register',
    projects: null,
    company_landing_theme: 'dark',
    catOption: [],
    project_size: 'large-4',
    toggleDetails: false,
    project: null,
    roles: null
  }

  componentWillMount() {
    let catOption = []
    const projects = agent.Project.getPubRegProj(this.props.artistInfo.id)
    this.props.onLoad(projects)
    projects.then(res => {
      res.projects.map((project, index) => {
        let cat = categoryOptions.find(k => k.value === project.category)
        if (cat && !catOption.find(j => j.value === cat.value))
            catOption.push(cat)
      })
      this.setState({ catOption: catOption, roles: this.props.roles })
    })
  }

  openDetails = (value, id, list) => {
    var project = list.filter(k => k.id === id)
    this.setState({ toggleDetails: value === 'yes' ? true : false, project: project[0] })
  }

  toggleButton(value, flag) {
      if (flag === 'register'){
          this.setState({ register: 'button header-button-selected', checkin: 'button header-button-unselected', pagestate: 'register' })
          
          this.props.onLoad(agent.Project.getPubRegProj(this.props.artistInfo.id)).then((e) => {
            console.log('success-projectlist', e)
          })
      }
      if (flag === 'checkin'){
          this.setState({ register: 'button header-button-unselected', checkin: 'button header-button-selected', pagestate: 'checkin' })
          // const projects = agent.Project.getCheckinProj(this.props.artistInfo.id)
          // this.props.onLoad(
          //     Promise.all([
          //         projects
          //     ])
          // )
          this.props.onLoad(agent.Project.getCheckinProj(this.props.artistInfo.id)).then((e) => {
            console.log('success-projectlist', e)
          })
      }
  }

  onChangeType(filter) {
      let projs = []
      if (filter == 0)
          projs = this.props.projects
      else
          projs = this.props.projects.filter(k => k.category === filter)
      this.setState({ projects: projs })
    }

  onChangeProjectName(filter) {
    let projs = []
    if (filter == '') //select all
      projs = this.props.projects
    else if (filter.length >= 3) //filter by project name
    {
      projs = this.props.projects.filter(k => k.name.toLowerCase().indexOf(filter.toLowerCase()) > -1)  //true
    }
    this.setState({ projects: projs })
  }

  onChangeGender(filter) {
    let roles = []
    let projs = []

    if (filter == 'both')
      roles = this.props.roles.filter(k => k.gender == 'both' || k.gender == 'female' || k.gender == 'male')
    else
      roles = this.props.roles.filter(k => k.gender == filter || k.gender == 'both')
    roles.map((item, i) => {
      let p = this.props.projects.filter(k => k.id == item.project_id)
      projs.push(p[0])
    })
    this.setState({ projects: projs})
  }

  render() {
    const textStyle = {
      background: '#fff',
      color: '#000'
    }
    const divFix1 = {
      paddingTop: '0rem'
    }
    const divFix2 = {
      textAlign: 'center'
    }
    const divFix3 = {
      paddingTop: '1rem'
    }
    const filterFix = {
      paddingTop: '1rem',
      paddingBottom: '2rem'
    }
    const pFix = {
      marginTop: '1rem',
      color: '#fff',
      fontSize: '27px'
    }
    const projRowFix = {
      paddingLeft: '3%',
      paddingRight: '3%'
    }
    const projRowFix2 = {
      paddingLeft: '0',
      paddingRight: '0'
    }
    const hidDiv = {
      display: 'none'
    };
    const selectFix = {
      backgroundColor: '#fff'
    }
    const filterTPadding = {
      paddingTop: '1rem'
    }
    const filterBPadding = {
      paddingBottom: '1rem'
    }
    const { handleSubmit, submitting, pristine, error, location } = this.props
    const { roles } = this.state
    let projects = this.state.projects ? this.state.projects : this.props.projects

    const artist_storage = JSON.parse(window.localStorage.getItem('artist_jwt'))
    let project_ids_joined = this.props.artistInfo.project_ids_joined

    if (artist_storage != null) {
      project_ids_joined = artist_storage.artist.project_ids_joined
    }

        // projects = this.state.pagestate === 'register' ?
        //     projects = projects.filter(k => k.pre_registration) : projects
        // projects = this.state.pagestate === 'checkin' ?
        //     projects = projects.filter(k => k.checkin_enabled) : projects
        // projects = this.state.projects ? this.state.projects.filter(k => k.company_id === 1429) :
        //     projects.filter(k => k.company_id === 1429)
    return (
      <div className="row main-wrapper" data-theme="dark">
          {
            !this.state.toggleDetails &&
            (<div className="column"><nav className="row action-nav">
              <div className="column filters filters-fix">
                <div style={filterTPadding} className="row">
                    <div style={filterFix} className="column filter-title">Filters</div>
                </div>
                <div style={filterBPadding} className="row">
                    <div className="column large-3">
                        <input style={textStyle} type="text" placeholder="SEARCH PROJECT NAME" onChange={e => this.onChangeProjectName(e.target.value)} />
                    </div>
                    <div className="column large-3">
                      <Field 
                          style={selectFix}
                          name="filter_type"
                          className="filter-select"
                          component="select"
                          onChange={(e) => this.onChangeType(e.target.value)}>
                          <option key={0} value={0}>PROJECT TYPES</option>
                          {
                            this.state.catOption.map(cat => (<option key={cat.id} value={cat.value}>{cat.label}</option>))
                          }
                        </Field>
                    </div>
                    <div className="column filter-column hide-content">
                        <Field 
                          name="filter_agerange"
                          className="filter-select" 
                          component="select">
                          <option key={0} value={0}>AGE-RANGE</option>
                        </Field>
                    </div>
                    <div className="column large-2 hide-content">
                        <Field 
                          style={selectFix}
                          name="filter_location"
                          className="filter-select" 
                          component="select">
                          <option key={0} value={0}>LOCATION</option>
                        </Field>
                    </div>
                    <div className="column large-3">
                        <Field
                          style={selectFix}
                          name="filter_gender"
                          className="filter-select"
                          placeholder="ALL GENDER"
                          component="select"
                          onClick={(e) => this.onChangeGender(e.target.value)}>
                            <option key='0' value='both'>GENDER</option>
                            <option key='1' value='male'>Male</option>
                            <option key='2' value='female'>Female</option>
                        </Field>
                    </div>
                    <div className="column large-3">
                      <Field 
                          style={selectFix}
                          name="filter_type"
                          className="filter-select"
                          component="select">
                          <option key={0} value={0}>STATUS</option>
                          <option key={1} value={1}>Applied</option>
                        </Field>
                    </div>
                </div>
              </div>
            </nav>
            <div className="row">
                <div className="column project-wrapper large-expand">
                    <div style={divFix1} className="row header-details2">
                      <div style={divFix2} className="column">
                        <button style={hidDiv} className={this.state.register} type="button" onClick={e => this.toggleButton(e.target.value, "register")}>
                            REGISTER
                        </button>
                        <button style={hidDiv} className={this.state.checkin} type="button" onClick={e => this.toggleButton(e.target.value, "checkin")}>
                            CHECK-IN
                        </button>
                        <p style={pFix}>You have already applied to the following projects.</p>
                      </div>
                    </div>
                    <div className="row large-12 project-list">
                        {
                            projects.length !== 0 ?
                            projects.map((project, index) => {
                                return (<div key={index + 1} className={classNames("column", this.state.project_size, "project", {
                                    'last-on-the-list' : (index + 1) === projects.length
                                })}>
                                    <a className="stretch-width" onClick={e => this.openDetails("yes", project.id, projects)}>
                                      <div style={projRowFix} className="row">
                                        <div style={projRowFix2} className="column img-holder">
                                            <div className="img-holder-sub">
                                                <img src={project.cover_url} />
                                            </div>
                                        </div>
                                        <div className="column project-name">
                                          <div className="row">
                                            <div className="column">
                                              <div className="row">
                                                <div className="column medium-8">{project.name}</div>
                                                <div className="column medium-4 end proj-category">{project.category}</div>
                                              </div>
                                            </div>
                                            <div style={divFix3} className="column">
                                              <div className="row">
                                                <div className="column medium-8">{project.company_name}</div>
                                                {
                                                  project_ids_joined.filter(k => k == project.id).length > 0 &&
                                                    (<div className="column medium-4 proj-status">
                                                      {
                                                        this.state.pagestate === 'register' ? 'applied ' : 'checked-in '
                                                      }
                                                      <span className="fa fa-check-circle"></span></div>)
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                </div>)
                            }) : this.state.pagestate === 'register' ? 
                                <h4 className="h4-text">There are currently no active projects available to audition for</h4> :
                                this.state.pagestate === 'checkin' ?
                                <h4 className="h4-text">There are currently no projects available for check-in</h4> :
                                <h2 className="h4-text">N.A</h2>
                        }
                    </div>
                </div>
            </div></div>)
          }
          <div>
          {
            this.state.toggleDetails && (
              <ProjectDetails projects={projects} project={this.state.project} 
                toggleDetails={this.state.toggleDetails} openDetails={this.openDetails}
                pagestate={this.state.pagestate}
                artistInfo={this.props.artistInfo}
                roles={roles} />
            )
          }
          </div>
      </div>
    )
  }
}



ProjectList = reduxForm({
  form: 'artistRegistrationWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(ProjectList)

const mapStateToProps = state => ({
    projects: state.projects.projects ? state.projects.projects : []
})


const mapDispatchToProps = (dispatch) => ({
  onLoad: payload =>
        dispatch({ type: 'COMPANY_LANDING_PAGE_NEW', payload: payload})
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectList)



// WEBPACK FOOTER //
// ./src/components/ProjectList.js